import { Carousel, Slide } from 'vue-carousel';
import {api} from "../api";
import Cookies from 'js-cookie';
import paymentHelper from '../utils/paymentHelper';
import orderHelper from '../utils/orderHelper';
import OrdersCarousel from '../../components/OrdersCarousel.vue';
import Registration from '../../components/registration.vue';
import Explanation from '../../components/explanation.vue';
import VideoWidget from '../../components/VideoWidget.vue';
import Calculator from '../../components/Calculator.vue';

export default {
    name: 'HomePage',

    components: {
        Carousel,
        Slide,
        Registration,
        OrdersCarousel,
        VideoWidget,
        Explanation,
        Calculator
    },

    mixins: [
        paymentHelper,
        orderHelper
    ],

    data () {
        return {
            reviews: [],
            articles: [],
            news: [],
            income: null,
            isUser: false,
            user: {},
            orderRawList: {},
            orders: [],
            isAuth: false,
            isRegLoading: false,
            timer: 0,
            showCalcRegForm: false,
            calculatorError: '',
            isCalculatorLoading: false,
            isShowCalculatorRegModal: false,
            isPaymentError: false,
            stepsLink: '/declarations',
            bannerAutoplay: true,
            calculator: {
                estate: true, // недвижимость
                morgage: false, // ипотека
                training: false, //образование
                training_child: false, // образование ребенка
                treatment: false, //лечение
                insurance: false, // страховка
                sport: false, // спорт
                investment: false, // ииис
                stock: false, //брокерский счет
            },
            isShowCalculator: false
        }
    },

    watch: {
        income: function() {
            this.calculatorError = '';
        }
    },

    computed: {
        formattedIncome: {
            get: function() {
                return this.income ? this.income.toLocaleString('ru-RU') : null;
            },

            set: function(newValue) {
                this.income = +newValue.replace(/\s/g, "");
            }
        }
    },

    methods: {
        toggleDeduction(type) {
            if (type === 'estate' && this.calculator[type]) {
                this.calculator.morgage = false;
            }

            if (type === 'training' && this.calculator[type]) {
                this.calculator.training_child = false;
            }

            this.calculator[type] = !this.calculator[type]
        },

        getReviews() {
            api.get('/discourse/random', {count: 6})
            .then(res => {
                if( res.status === 200) {
                    this.reviews = res.data;
                }
            }).catch(() => {
                
            });
        },

        getNews() {
            api.get('/news/recent/2/')
                .then((res) => {
                    if (res.status === 200 && res.data) {
                        this.news = res.data;
                    }
                })
                .catch(() => {});
        },

        getArticles() {
            api.get('/article/random/5/')
                .then((res) => {
                    if (res.status === 200) {
                        this.articles = res.data;
                    }
                })
                .catch(() => {});
        },

        getContent() {
            //this.getReviews();
            this.getNews();
            this.getArticles();
        },

        objectLength(value) {
            if (typeof(value) !== 'object') {
                return 0;
            }
            return Object.keys(value).length;
        },

        scrollFromHash() {
            if (!location.hash) {
                return
            }

            const hash = location.hash.slice(1);
            const blockInfo = document.getElementById(hash);
            
            if (hash && blockInfo) {
                this.scrollToElement(blockInfo);
                history.replaceState("", document.title, window.location.pathname + window.location.search);
            }
        },

        scrollToElement(element) {
            if (element) {
                requestAnimationFrame(() => {
                    const yOffset = -document.querySelector('#header').offsetHeight;
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

                    window.scrollTo({top: y, behavior: 'smooth'});
                });
            }
        },

        scrollToOrders() {
            this.scrollToElement(document.querySelector('.orders-block'));
        },

        scrollToTurnkey() {
            this.scrollToElement(document.querySelector('.home-turnkey'));
        },

        scrollToConcierge() {
            this.scrollToElement(document.querySelector('.home-concierge'));
        },

        scrollToTrader() {
            this.scrollToElement(document.querySelector('#trader'));
        },

        scrollToFast() {
            this.scrollToElement(document.querySelector('.home-fast'));
        },

        scrollToPension() {
            this.scrollToElement(document.querySelector('.home-pension-banner'));
        },

        scrollToRega() {
            this.scrollToElement(document.querySelector('.submain__rega'));
        },

        scrollToOneDayReturn() {
            this.scrollToElement(document.querySelector('.home-submain-banner .submain__content'));
        },

        scrollToForeignReports() {
            this.scrollToElement(document.querySelector('.home-foreign-reports-block'));
        },

        triggerPartsUpdate() {
            document.dispatchEvent(new CustomEvent('headerGetProfile'));
        },

        checkCalculatorParams() {
            this.calculatorError = '';
            const data = Object.assign({}, this.calculator);
            let areActiveItems = false;

            if (!Object.values(this.calculator).every(item => item === false)) {
                areActiveItems = true;
            }

            data['salary'] = parseInt(this.income, 10);

            if (!areActiveItems) {
                this.calculatorError = 'Выберите хотя бы одну категорию трат';
                return false;
            }

            if (isNaN(data['salary']) || data['salary'] <= 0) {
                this.calculatorError = 'Укажите ваш официальный доход в месяц';
                return false;
            }

            return true;
        },

        saveCalculator() {
            if (!this.checkCalculatorParams()) {
                return;
            }

            const data = Object.assign({}, this.calculator);
            data['salary'] = parseInt(this.income, 10);

            this.isCalculatorLoading = true;

            api.post('/v3/user/selectionCalculator', data)
                .then(() => {
                    api.get('/order/list')
                        .then((res) => {
                            const ORDER_SID_CHECK_DOCS = 35;
                            this.initCreateOrder(ORDER_SID_CHECK_DOCS, res.data, { open: 'chat' });
                        }).catch(() => {
                            this.calculatorError = 'При расчёте произошла ошибка';
                        });
                })
                .catch(() => {
                    this.calculatorError = 'При расчёте произошла ошибка';
                    this.isCalculatorLoading = false;
                });
        },

        showCalculatorRegModal() {
            if (!this.checkCalculatorParams()) {
                return;
            }

            this.isShowCalculatorRegModal = true;
            document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'home_calculator_button' }}));
        },

        showCalculatorRegForm() {
            this.showCalcRegForm = true;
            document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'home_calculator_form_show' }}));
        },

        callbackRegCalculator() {
            this.showCalcRegForm = false;
            this.isShowCalculatorRegModal = false;
            this.saveCalculator();
        },

        getProfile() {
            return api.get('/v3/user/profile')
            .then(res => {
                this.isUser = true;

                this.user = res.data.data;
            }).catch(() => {
                this.isUser = false;
            });
        },

        initPromocodeRedirect() {
            if (this.isUser) {
                location = '/profile/#promocode';
            } else {
                sessionStorage.setItem('open_promocode_input', 1);
                document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'home_promocode_button' }}));
                location = '/user/signup/';
            }
        },

        scrollToOrder(selector, openShortReg = false) {
            this.$refs.ordersCarousel.scrollToOrder(selector, openShortReg);
            document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'home_situations_order' }}));
        },

        scrollToMainRega() {
            this.scrollToElement(document.querySelector('.main-rega-block'));
        },

        regCallback() {
            location = this.stepsLink;
        },

        toggleFaq(e) {
            e.currentTarget.closest('.faq-item').classList.toggle('active');
        },

        toggleStepInfo(e) {
            e.currentTarget.closest('.process__step').classList.toggle('active');
        },

        toggleReviewText(e) {
            e.currentTarget.closest('.carousel-item').classList.toggle('active');
        }
    },

    created() {
        if (localStorage.getItem('calculator_progress')) {
            this.isShowCalculator = true;
        }
    },

    mounted () {
        this.getContent();
        
        if (Cookies.get('user_token')) {
            this.getProfile();
        } else {
            this.isUser = false;
        }

        window.setTimeout(this.scrollFromHash, 300);
        window.addEventListener('scroll', this.checkScroll);

        if (this.isFailUrl()) {
            this.isPaymentError = true;

            setTimeout(() => {
                this.isPaymentError = false;
            }, 15000);
        }

        setTimeout(() => {
            this.bannerAutoplay = false;
        }, 32000);
    }
}
